import { useCallback } from 'react';

export const useOnEdgesRemove = () =>
  useCallback(({ edgesToRemove, onConnect }) => {
    edgesToRemove.forEach((edge) => {
      onConnect({ ...edge, removeTarget: true, isElseEdge: edge.id?.includes('e-else-') });
    });
  }, []);
